<div class="container my-4">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="dateInput" class="form-label">Fecha de cosecha:</label>
      <input
        type="date"
        id="dateInput"
        class="form-control"
        formControlName="date"
      />
      <div
        class="text-danger"
        *ngIf="form.get('date')?.invalid && form.get('date')?.touched"
      >
        La fecha es obligatoria.
      </div>
    </div>

    <div class="mb-3">
      <label for="kgInput" class="form-label">Kilos cosechados:</label>
      <input
        type="number"
        id="kgInput"
        class="form-control"
        formControlName="kg"
        min="1"
      />
      <div
        class="text-danger"
        *ngIf="form.get('kg')?.invalid && form.get('kg')?.touched"
      >
        El número es obligatorio y debe ser mayor a 0.
      </div>
    </div>

    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      Cosechar
    </button>
  </form>
</div>
